import {
  GET_ALL_BLOGS,
  ADD_NEW_BLOG,
  REMOVE_SINGLE_BLOG,
  ALL_BLOGS_CURRENT_PAGE,
  TOTAL_BLOGS_PAGES,
  GET_ALL_PRIZES,
  PRIZES_CURRENT_PAGE,
  TOTAL_PRIZES_PAGES,
  REMOVE_PRIZE,
  NOTIFICATIONS_CURRENT_PAGE,
  GET_ALL_NOTIFICATIONS,
  TOTAL_NOTIFICATIONS_PAGES,
  GET_SINGLE_PRIZE,
  GET_ALL_POINTS,
  POINTS_CURRENT_PAGE,
  TOTAL_POINTS_PAGES,
  GET_ALL_PURCHASES,
  PURCHASES_CURRENT_PAGE,
  PURCHASES_TOTAL_PAGES,
  GET_SINGLE_PURCHASE,
  GET_ALL_POINTS_BANK,
  POINTS_BANK_CURRENT_PAGE,
  TOTAL_POINTS_BANK_PAGES,
} from "../../@jumbo/constants/ActionTypes";

export const setAllNews = (News) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_BLOGS,
      payload: News,
    });
  };
};

export const setBlogCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: ALL_BLOGS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setBlogTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_BLOGS_PAGES,
      payload: totPageCnt,
    });
  };
};

export const addBlog = (blog) => {
  return (dispatch) => {
    dispatch({
      type: ADD_NEW_BLOG,
      payload: blog,
    });
  };
};
export const removeBlog = (blog) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_SINGLE_BLOG,
      payload: blog,
    });
  };
};

export const setAllPrizes = (prizes) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_PRIZES,
      payload: prizes,
    });
  };
};

export const setPrizesCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: PRIZES_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setPrizesTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_PRIZES_PAGES,
      payload: totPageCnt,
    });
  };
};

export const setAllNotifcations = (notifications) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_NOTIFICATIONS,
      payload: notifications,
    });
  };
};

export const setNotificationsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: NOTIFICATIONS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setNotificationsTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_NOTIFICATIONS_PAGES,
      payload: totPageCnt,
    });
  };
};

export const removePrize = (prize) => {
  return (dispatch) => {
    dispatch({
      type: REMOVE_PRIZE,
      payload: prize,
    });
  };
};

export const getSinglePrize = (prize) => {
  return (dispatch) => {
    dispatch({
      type: GET_SINGLE_PRIZE,
      payload: prize,
    });
  };
};

export const getAllPoints = (points) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_POINTS,
      payload: points,
    });
  };
};

export const setPointsCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: POINTS_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setPointsTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_POINTS_PAGES,
      payload: totPageCnt,
    });
  };
};

export const getAllPointsBank = (pointsBank) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_POINTS_BANK,
      payload: pointsBank,
    });
  };
};

export const setPointsBankCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: POINTS_BANK_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setPointsBankTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: TOTAL_POINTS_BANK_PAGES,
      payload: totPageCnt,
    });
  };
};

export const setPurchaseList = (purchases) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_PURCHASES,
      payload: purchases,
    });
  };
};

export const setPurchasesCurrentPage = (currentPage) => {
  return (dispatch) => {
    dispatch({
      type: PURCHASES_CURRENT_PAGE,
      payload: currentPage,
    });
  };
};

export const setPurchasesTotalPages = (totPageCnt) => {
  return (dispatch) => {
    dispatch({
      type: PURCHASES_TOTAL_PAGES,
      payload: totPageCnt,
    });
  };
};

export const getSinglePurchase = (purchase) => {
  return (dispatch) => {
    dispatch({
      type: GET_SINGLE_PURCHASE,
      payload: purchase,
    });
  };
};
